import { render, staticRenderFns } from "./Form1CaseInformationSearch.vue?vue&type=template&id=2b3f2f06&scoped=true"
import script from "./Form1CaseInformationSearch.vue?vue&type=script&lang=ts"
export * from "./Form1CaseInformationSearch.vue?vue&type=script&lang=ts"
import style0 from "./Form1CaseInformationSearch.vue?vue&type=style&index=0&id=2b3f2f06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3f2f06",
  null
  
)

export default component.exports